<template>
  <div id="app">
    <navbar></navbar>
    <router-view/>
  </div>
</template>

<script>
import navbar from './components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    navbar
  }
}
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

body{
  margin:0px;
}

.slice{
    padding:20px 0px;
}

.lang-header{
  text-align: left;
  margin-top:100px;
  margin-bottom:20px;

  .step-box{
    //border:1px solid #00000020;
    padding:10px 5px;
    height:100%;
    border-radius:5px;
   

    .step-title{
      font-size:18px;
      color:#333;
      font-weight: bold;
      text-align: center;
    }

    .step-age{
      font-size:14px;
      color:#f1f1f1;
      margin:15px 0px;
      text-align: center;

      .age{
        background:#37c18c;
        border-radius: 4px;
        width:60px; 
        margin:auto;
        padding:5px;
        text-align: center;
        color:white;
      }
    }

    .step-desc{
      color:#666;
      font-size:15px;
      margin-top:10px;
      padding-top:15px;
      text-align: center;
    }
  }
}

</style>
